import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {modalOperations} from "../../../../../../../../../ducks/modal/index";
import DOTNumberModal from './dotNumberModalComponent'
import {alertsOperations} from "../../../../../../../../../ducks/alerts/index";
import {Rnd} from 'react-rnd';
import usersService from "../../../../../../../../../services/usersService";

class DOTNumberModalContainer extends Component {
  constructor(props) {
    super(props);

    //the props are coming in on the info prop of the modal container, so map them to the ones we need
    this.state = {};
  }

  componentDidMount() {
    this.showDOTModal();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.info.selectedClientId !== prevProps.info.selectedClientId) {
      this.showDOTModal();
    }
  }

  showDOTModal = async () => {
    try {
      const response = await usersService.getClientChildrenForUser(
        this.props.info.selectedClientId,
        this.props.auth.user._id
      );
  
      const dotListWithDupes = response
        .filter((item) => item.DOTNumber && item.DOTNumber !== '')
        .map((item) => ({ value: item.DOTNumber, label: item.DOTNumber }));
  
        const dotList = Array.from(
          new Map(dotListWithDupes.map(item => [item.value.trim(), item])).values()
        );
  
      if (dotList && dotList.length === 1) {
        // If there is only one location, don't show the modal
        this.props.hideModal(false, [dotList[0].value]);
      } else if (dotList && dotList.length === 0) {
        // If no DOT numbers are found
        this.props.addAlert('There are no DOT numbers associated with this location.', 'danger');
        this.props.hideModal(false, []);
      } else {
        this.setState({ dotList });
      }
    } catch (err) {
      console.error('Error fetching DOT numbers:', err);
    }
  };

  selectNumbers = () => {
    if (this.state.selectedItems && this.state.selectedItems.length > 0) {
      this.props.hideModal(false, this.state.selectedItems.map((item) => item.value));
    } else {
      this.props.hideModal(false, []);
    }

  };

  handleDOTListChange = (options) => {
    this.setState({selectedItems: options});
  };

  render() {

    const {dotList} = this.state;
    if (!dotList) {
      return null;
    }
    return (
        <Fragment>
          <Modal isOpen={true}>
            <Rnd dragHandleClassName={'modal-header'} enableResizing={false}>
              <ModalHeader className={'cursor-move'}>Select DOT Number(s) to run report for</ModalHeader>
              <ModalBody>
                <DOTNumberModal dotList={dotList} onDOTListChange={this.handleDOTListChange}
                />
              </ModalBody>
              <ModalFooter>
                <button className={'btn btn-primary btn-sm'} id='copy' onClick={this.selectNumbers}>OK
                </button>
              </ModalFooter>
            </Rnd>
          </Modal>
        </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth
});

const mapDispatchToProps = {
  hideModal: modalOperations.hideModal,
  addAlert: alertsOperations.addAlert
};

export default connect(mapStateToProps, mapDispatchToProps)(DOTNumberModalContainer);